var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrowWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7687_13313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3753 19.1654C14.2492 19.1661 14.1242 19.1419 14.0074 19.0942C13.8907 19.0466 13.7845 18.9763 13.6949 18.8875L6.9866 12.1791C6.89678 12.09 6.82548 11.984 6.77683 11.8673C6.72817 11.7505 6.70312 11.6252 6.70312 11.4987C6.70312 11.3722 6.72817 11.2469 6.77683 11.1302C6.82548 11.0134 6.89678 10.9074 6.9866 10.8183L13.6949 4.10996C13.7843 4.02061 13.8904 3.94973 14.0071 3.90137C14.1239 3.85301 14.249 3.82812 14.3753 3.82812C14.5017 3.82812 14.6268 3.85301 14.7436 3.90137C14.8603 3.94973 14.9664 4.02061 15.0558 4.10996C15.1451 4.19932 15.216 4.30539 15.2644 4.42214C15.3127 4.53889 15.3376 4.66401 15.3376 4.79038C15.3376 4.91674 15.3127 5.04187 15.2644 5.15862C15.216 5.27536 15.1451 5.38144 15.0558 5.4708L9.01826 11.4987L15.0558 17.5266C15.1456 17.6157 15.2169 17.7217 15.2655 17.8385C15.3142 17.9553 15.3392 18.0805 15.3392 18.207C15.3392 18.3336 15.3142 18.4588 15.2655 18.5756C15.2169 18.6924 15.1456 18.7984 15.0558 18.8875C14.9662 18.9763 14.86 19.0466 14.7433 19.0942C14.6265 19.1419 14.5015 19.1661 14.3753 19.1654Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7687_13313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrowWhite);
export default __webpack_public_path__ + "static/media/BackArrowWhite.7073b2375e29fa2b158fee1f5d266547.svg";
export { ForwardRef as ReactComponent };